import { useState, useRef } from 'react';
import { getTimeFromFormat, isFormatDateValid } from 'utils/3catinfo/dateHelper';
import Imatge from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Icona from 'components/3catinfo/ui/Icona';
import LogoDirecte from 'components/3catinfo/ui/LogoDirecte';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import Boto from 'components/3catinfo/Boto';
import __isEmpty from 'lodash/isEmpty';
import __get from 'lodash/get';
import clsx from 'clsx';
import styles from './playeraudio.module.scss';

const CanalDirecte = (props) => {
    const { id, directe } = props;

    if (!directe) return <></>;

    return (
        <div className={styles.logoCanal}>
            <Icona icona='directes' alt='Directe' className={styles.ico_directe} isBlanc={true} />{' '}
            <LogoDirecte canal={id} logo='light' className={styles.logoDirecte} />
        </div>
    );
};

const PlayerAudio = (props) => {
    const { id, playerVideoTagId, imatgesAudio, imatges, titolAudio, duradaAudio, directe, numColumnsRow } = props;

    const imatgesPlayer = imatgesAudio || imatges;
    const [playerVisible, setPlayerVisible] = useState(false);
    const [titol, setTitol] = useState(titolAudio);
    const [imatge, setImatge] = useState(imatgesPlayer);
    const [durada, setDurada] = useState(duradaAudio);
    const [mediaLoaded, setMediaLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const playerRef = useRef();

    const pushMediaModel = (response) => {
        if (directe) {
            setTitol(__get(response, 'attributes.informacio.attributes.arafem.attributes.titol'));
            let imatgeMedia = __get(response, 'attributes.imatges.models[0].attributes');
            if (imatgeMedia) {
                imatgeMedia.text = imatgeMedia?.url;
                setImatge([imatgeMedia]);
            }
        } else {
            if (!titol) setTitol(__get(response, 'attributes.informacio.attributes.titol'));
            if (!imatge) {
                let imatgeMedia = __get(response, 'attributes.keyframes.models[0].attributes');
                if (imatgeMedia) {
                    imatgeMedia.text = imatgeMedia?.url;
                    setImatge([imatgeMedia]);
                }
            }
            if (!durada) setDurada(__get(response, 'attributes.informacio.attributes.durada.attributes.text'));
        }
        setMediaLoaded(true);
    };

    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            setIsLoading(false);
        });
    };

    const stylesInfoAudio = clsx({
        [styles.infoWrapper]: true,
        [styles.hidden]: playerVisible
    });

    const stylesPlayerAudio = clsx({
        [styles.audio]: !directe,
        [styles.audioDirecte]: directe,
        [styles.hidden]: !playerVisible || isLoading
    });

    return (
        <>
            <div className={styles.playerAudio}>
                <div className={styles.content}>
                    {mediaLoaded && (
                        <>
                            <div className={styles.imatge}>
                                <Imatge
                                    imatges={imatge}
                                    tipus='web_player_poster_background'
                                    layout='fill'
                                    objectFit='contain'
                                    mostrarRecurs={false}
                                />
                            </div>
                            <div className={styles.info}>
                                <CanalDirecte id={id} directe={directe} />
                                <div className={styles.titolWrapper}>
                                    <h2 className={styles.titol}>{titol}</h2>
                                </div>

                                <div className={stylesInfoAudio}>
                                    <div className={styles.duradaWrapper}>
                                        {durada && isFormatDateValid(durada, 'HH:mm:ss') && (
                                            <>
                                                <Icona
                                                    className={styles.ico_clock}
                                                    mida={24}
                                                    icona='rellotge'
                                                    isBlanc={true}
                                                    alt='Temps'
                                                    ariaHidden={true}
                                                />
                                                <span className={styles.minuts}>{getTimeFromFormat(durada)}</span>
                                            </>
                                        )}
                                    </div>
                                    <div className={styles.boto}>
                                        <Boto
                                            isIconaDreta={true}
                                            onClick={() => {
                                                setPlayerVisible(true);
                                                playerRef?.current?.play();
                                            }}
                                            tag='button'
                                            iconaInline={true}
                                            text={directe ? 'Escolta-ho en directe' : 'Escolta-ho ara'}
                                            icona='auriculars_ple'
                                            fons='fonsContenidorNegre'
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <>
                    {isLoading && playerVisible && <LoadingPlayer numColumnsRow={numColumnsRow} />}
                    <div className={stylesPlayerAudio}>
                        <Player
                            ref={playerRef}
                            playerVideoTagId={playerVideoTagId}
                            id={id}
                            autoPlay={false}
                            directe={directe}
                            tipus='audio'
                            estils={directe ? 'minutaminutAudio' : 'audioNoti'}
                            imatges={imatge}
                            pushMediaModel={pushMediaModel}
                            playerControllerInstance={playerControllerInstance}
                        ></Player>
                    </div>
                </>
            </div>
        </>
    );
};

PlayerAudio.defaultProps = {
    directe: false
};

export default PlayerAudio;
